import {toast} from "react-toastify";

/**
 * @return {Object}
 */
function Validator(job, notify) {
  const required = {
    book_in_date: "Booked In Date",
    department: "Department"
  };

  const requiredNested = {
    vehicle: "registration",
    customer: "id",
    workshop: "id"
  };

  let missing = [];
  let missingCashSale = []
  let missingPartSuppliers = [];
  let invalidWorkTypes = [];
  let invalidWarrantyClaims = [];
  let missingTrackingOptions = []

  for (let field in required) {
    if (!job[field] || job[field].length === 0) {
      missing.push(required[field]);
    }
  }

  for (let field in requiredNested) {
    if (
      !job[field] ||
      !job[field][requiredNested[field]] ||
      job[field][requiredNested[field]].length === 0
    ) {
      missing.push(field);
    }
  }

  job.work_items.forEach((item,index) => {
    if(!item.work_type){
      invalidWorkTypes.push(item.description || ("Work Item "+(index+1)))
    }
    else if((!item.warranty_claimed || item.warranty_claimed === "BLANK") && item.work_type.warranty_claim){
      invalidWarrantyClaims.push(item.description || ("Work Item "+(index+1)))
    }
    item.parts.forEach(part => {
      if (!part.supplier || !part.supplier.id) {
        missingPartSuppliers.push(part.name || "Unnamed Part");
      }
      if (!(!!part.supplier_tracking_option) || !(!!part.customer_tracking_option)){
        missingTrackingOptions.push(item.description || ("Part "+(index+1)))
      }
    });
    if(!(!!item.supplier_tracking_option) || !(!!item.customer_tracking_option)){
      missingTrackingOptions.push(item.description || ("Work Item "+(index+1)))
    }
  });

  if(job.customer && job.customer.is_cash_sale){
    let cash_sale = job.cash_sale.filter(sale => sale.contact === job.customer.id);
    cash_sale = cash_sale[0];
    if(!(!!cash_sale)){
      missingCashSale.push("cash sale doesnt exist")
    }
    else {
      if (!(!!cash_sale.name)) {
        NotificationManager.warning("Cash Sale Name is required");
        // We do this so we can check at the end if it is still valid
        missingCashSale.push("name");
      }
      if (!(!!cash_sale.address)) {
        NotificationManager.warning("Cash Sale Address is required");
        missingCashSale.push("address");
      }
    }
  }

  if(job.customer2 && job.customer2.is_cash_sale){
    let cash_sale = job.cash_sale.filter(sale => sale.contact === job.customer2.id);
    cash_sale = cash_sale[0];
    if(!(!!cash_sale)){
      missingCashSale.push("cash sale doesnt exist")
    }
    else {
      if (!(!!cash_sale.name)) {
        NotificationManager.warning("Cash Sale Name is required");
        // We do this so we can check at the end if it is still valid
        missingCashSale.push("name");
      }
      if (!(!!cash_sale.address)) {
        NotificationManager.warning("Cash Sale Address is required");
        missingCashSale.push("address");
      }
    }
  }

  if (notify) {
    missing.forEach(name => {
      toast.warning(
        `You must specify a ${name}`, {position: "top-right"});
    });

    missingPartSuppliers.forEach(name => {
      toast.warning(
        `Part ${name} is missing a supplier!`, {position: "top-right"});
    });

    invalidWorkTypes.forEach(name => {
      toast.warning(
          `You must specify a work type for ${name}`, {position: "top-right"});
    });

    invalidWarrantyClaims.forEach(name => {
      toast.warning(
          `You must specify if warranty has been claimed for ${name}`, {position: "top-right"});
    });

    missingTrackingOptions.forEach(name => {
       toast.warning(
          `You must specify tracking options for ${name}`, {position: "top-right"});
    });
  }
  return {
    missingPartSuppliers: missingPartSuppliers,
    missing: missing,
    invalidWorkTypes: invalidWorkTypes,
    invalidWarrantyClaims: invalidWarrantyClaims,
    missingTrackingOptions: missingTrackingOptions,
    result: missing.length === 0 && missingPartSuppliers.length === 0 && invalidWorkTypes.length === 0 && missingTrackingOptions.length === 0 && missingCashSale.length === 0 &&  invalidWarrantyClaims.length === 0
  };
}

export default Validator;
